/* Fix aria-autocomplete, aria-expanded, aria-activedescendant, and aria-labelledby issue */
  try {
    document.addEventListener('DOMContentLoaded', function () {
      const timeoutDuration = 5000;
      const cleanInputAttributes = (input) => {
        input.removeAttribute('aria-autocomplete');
        input.removeAttribute('aria-expanded');
        input.removeAttribute('aria-activedescendant');
        input.removeAttribute('aria-labelledby');
      };
      const cleanDivAttributes = (div) => {
        div.removeAttribute('aria-labelledby');
      };
      const inputSelector = '#scoreDropdownInput';
      const divSelector = '.yotpo-main-layout.yotpo-main-reviews-widget';
      const cleanOnceAvailable = () => {
        const input = document.querySelector(inputSelector);
        const div = document.querySelector(divSelector);
        if (input) {
          cleanInputAttributes(input);
          new MutationObserver(() => cleanInputAttributes(input)).observe(input, {
            attributes: true,
            attributeFilter: [
              'aria-autocomplete',
              'aria-expanded',
              'aria-activedescendant',
              'aria-labelledby'
            ]
          });
        }
        if (div) {
          cleanDivAttributes(div);
          new MutationObserver(() => cleanDivAttributes(div)).observe(div, {
            attributes: true,
            attributeFilter: ['aria-labelledby']
          });
        }
        if (input && div) {
          observer.disconnect();
          clearTimeout(timeoutId);
        }
      };
      const observer = new MutationObserver(() => cleanOnceAvailable());
      observer.observe(document.body, { childList: true, subtree: true });
      const timeoutId = setTimeout(() => {
        observer.disconnect();
      }, timeoutDuration);
    });
  } catch (error) {}

/* Add role for tabindex = 0 elements */
  try {
    document.addEventListener('DOMContentLoaded', function () {
        const timeoutDuration = 5000;
        const updateRoles = () => {
        const spans = document.querySelectorAll(
            '.yotpo-star-rating-highly-rated-topics-text, .yotpo-topic-underline'
        );
        spans.forEach(span => {
            if (!span.hasAttribute('role') || span.getAttribute('role') !== 'button') {
            span.setAttribute('role', 'button');
            new MutationObserver(() => {
                if (span.getAttribute('role') !== 'button') {
                span.setAttribute('role', 'button');
                }
            }).observe(span, { attributes: true, attributeFilter: ['role'] });
            }
        });
        if (spans.length > 0) {
            observer.disconnect();
            clearTimeout(timeoutId);
        }
        };
        const observer = new MutationObserver(() => updateRoles());
        observer.observe(document.body, { childList: true, subtree: true });
        const timeoutId = setTimeout(() => {
        observer.disconnect();
        }, timeoutDuration);
    });
  } catch (error) { }


/* Fix Element with role combobox missing accessible name */
  try {
    document.addEventListener('DOMContentLoaded', function () {
      const timeoutDuration = 5000;
      const targetSelector = '.yotpo-score-filter.yotpo-score-filter-container';
      const addAriaLabel = (element) => {
        if (!element.hasAttribute('aria-label')) {
          element.setAttribute('aria-label', 'Filter by rating');
        }
      };
      const initLabeling = () => {
        const target = document.querySelector(targetSelector);
        if (target) {
          addAriaLabel(target);
          new MutationObserver(() => addAriaLabel(target)).observe(target, {
            attributes: true,
            attributeFilter: ['aria-label'],
          });
          observer.disconnect();
          clearTimeout(timeoutId);
        }
      };
      const observer = new MutationObserver(() => initLabeling());
      observer.observe(document.body, { childList: true, subtree: true });
      const timeoutId = setTimeout(() => {
        observer.disconnect();
      }, timeoutDuration);
    });
  } catch (error) { }
